export default [
  {
    path: "/wish",
    component: () => import("@/views/wishACT/index"),
    children: [
      {
        path: "home",
        component: () => import("@/views/wishACT/home"),
        meta: {
          title: "许愿墙"
        }
      },
      {
        path: "detail",
        component: () => import("@/views/wishACT/detail"),
        meta: {
          title: "话题详情",
          keepAlive: true // 后续如果home有了，这个需要改一下
        }
      },
      {
        path: "detail2",
        component: () => import("@/views/wishACT/detail2"),
        meta: {
          title: "话题详情",
          keepAlive: true // 后续如果home有了，这个需要改一下
        }
      },
      {
        path: "winner",
        component: () => import("@/views/wishACT/winner"),
        meta: {
          title: "抽奖公示"
        }
      },
      {
        path: "comment",
        component: () => import("@/views/wishACT/comment"),
        meta: {
          title: "发表评论",
          vilidate: 3
        }
      },
      {
        path: "default",
        component: () => import("@/views/wishACT/default"),
        meta: {
          title: "维护中"
        }
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/wish.js